import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=1b1ee666&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=ts&"
export * from "./RegisterUser.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=1b1ee666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ee666",
  null
  
)

export default component.exports